import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { Router } from '@angular/router'
import { finalize, Subject, takeUntil } from 'rxjs'
import { DishModel } from 'src/app/models/dish.model'
import { AyBService } from 'src/app/services/api/ayb.service'
import Swal from 'sweetalert2'
import { DialogPlatosComponent } from './dialog-platos/dialog-platos.component'

@Component({
  selector: 'app-platos',
  templateUrl: './platos.component.html',
  styleUrls: ['./platos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlatosComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$ = new Subject<boolean>()

  isLoading = true
  dishes: DishModel[] = []
  displayedColumns: (keyof DishModel | 'modificar')[] = [
    'codigoPlato',
    'nombrePlato',
    'categoria',
    'observaciones',
    'modificar'
  ]
  dataSource = new MatTableDataSource<DishModel>()
  paginator!: MatPaginator
  @ViewChild(MatPaginator) set matPaginator (paginator: MatPaginator) {
    this.paginator = paginator
    if (this.paginator) {
      this.dataSource.paginator = paginator
    }
  }
  sort!: MatSort
  @ViewChild(MatSort, { static: false }) set matSort (sort: MatSort) {
    this.sort = sort
    if (this.sort) {
      this.dataSource.sort = sort
    }
  }
  constructor (
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly cdRef: ChangeDetectorRef,
    private readonly aybService: AyBService
  ) {}
  ngOnInit (): void {
    this.getAllPlatos()
  }
  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }
  applyFilter (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }
  getAllPlatos () {
    this.aybService
      .queryGetAllPlatos()
      .pipe(
        takeUntil(this._unsubscribeOnDestroy$),
        finalize(() => {
          this.isLoading = false
          this.cdRef.markForCheck()
        })
      )
      .subscribe({
        next: response => {
          console.log(response)
          this.dishes = response.getAllPlatos
          this.dataSource.data = this.dishes
          this.dataSource.paginator = this.paginator
          this.dataSource.sort = this.sort
        },
        error: error => {
          console.error('Error fetching dishes:', error)
        }
      })
  }

  openDialogAdd (): void {
    let dialogConfig = new MatDialogConfig()
    dialogConfig.data = {
      nombre: '',
      categoria: '',
      observaciones: '',
      title: 'Agregar Plato',
      estado: 2
    }
    dialogConfig.width = '25rem'

    let dialogRef = this.dialog.open(DialogPlatosComponent, dialogConfig)

    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.getAllPlatos()
      }
    })
  }

  deletePlato (dishToDelete: DishModel): void {
    Swal.fire({
      title: `¿Desea eliminar este registro? "${dishToDelete.toString()}"`,
      showCancelButton: true,
      confirmButtonText: 'Sí',
      confirmButtonColor: '#e95a1a',
      cancelButtonText: 'No'
    }).then(result => {
      if (result.isConfirmed) {
        this.aybService
          .mutationDeletePlato(dishToDelete?.id || '')
          .pipe(takeUntil(this._unsubscribeOnDestroy$))
          .subscribe(data => {
            console.log(data)
            this.getAllPlatos()
            this.cdRef.markForCheck()
          })
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'El registro se eliminó satisfactoriamente.',
          showConfirmButton: false,
          timer: 4000
        })
      }
    })
  }

  navigateToDetallePlato (platoId: number) {
    this.router.navigate([`/detalle-plato/${platoId}`])
  }
}
